__turbopack_context__.v({
  "active": "ImageGallery-module__YcVL1W__active",
  "gallery": "ImageGallery-module__YcVL1W__gallery",
  "hero": "ImageGallery-module__YcVL1W__hero",
  "heroFooter": "ImageGallery-module__YcVL1W__heroFooter",
  "heroWrapper": "ImageGallery-module__YcVL1W__heroWrapper",
  "thumbBtn": "ImageGallery-module__YcVL1W__thumbBtn",
  "thumbImg": "ImageGallery-module__YcVL1W__thumbImg",
  "thumbRow": "ImageGallery-module__YcVL1W__thumbRow",
  "tokenCost": "ImageGallery-module__YcVL1W__tokenCost",
});
